"use strict";
'use es6';
/**
 * DEPRECATED
 * ----------
 * These constants should no longer be used directly. Instead use the functions
 * defined in `crm_data/flux/LoadingStatus`.
 */

/**
 * An empty value that was loaded from the server is represented by `null`.
 */

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LOADING = exports.EMPTY = void 0;
var EMPTY = null;
/**
 * An value that has not yet loaded from the server is represented
 * by `undefined`.
 *
 * By using `undefined`, abstractions like `ComponentWithLoadingState` can
 * systematically determine the loading state of a component.
 */

exports.EMPTY = EMPTY;
var LOADING = undefined;
exports.LOADING = LOADING;